import { Box, Heading, SkeletonText, Text } from "@chakra-ui/react";
import { GradientMaskedImage } from "components/gradient-masked-image";
import type { PropertyBannerDetailsProps } from "types/property";

export function TenantPortalPropertyBannerDetails({
  isLoading,
  title,
  subtitle,
  backgroundImage,
  topLeftElement,
  leftElement,
  rightElement,
}: PropertyBannerDetailsProps) {
  const inner = (
    <Box
      p={[6, 12]}
      display={"flex"}
      flexDir={"row"}
      rowGap={{ base: 5, md: 10 }}
      flexWrap={"wrap"}
      columnGap={4}
    >
      <Box
        flex={1}
        display={"flex"}
        flexDir={"column"}
        gap={{ base: 0, lg: "60px" }}
      >
        {topLeftElement && (
          <Box
            display={{ base: "none", md: "flex" }}
            mb={{ base: 4, md: 8, lg: 0 }}
          >
            {topLeftElement}
          </Box>
        )}
        <Box mb={{ base: 4, md: 8, lg: 0 }}>
          <SkeletonText
            noOfLines={1}
            skeletonHeight={"30px"}
            maxW={isLoading ? "300px" : "100%"}
            isLoaded={!isLoading}
            color={backgroundImage ? "white" : "client.accent.text"}
          >
            <Heading
              fontSize={{ base: "6xl", sm: "7xl" }}
              fontWeight={{ base: 800, md: 700 }}
              lineHeight={{ base: "30px", sm: "40px" }}
              w={{ base: "100%", sm: "20ch" }}
            >
              {title}
            </Heading>
          </SkeletonText>
        </Box>
        <Box>
          <SkeletonText
            noOfLines={2}
            skeletonHeight={"18px"}
            maxW={isLoading ? "300px" : { base: "100%", md: "80%" }}
            isLoaded={!isLoading}
            color={backgroundImage ? "white" : "client.accent.text"}
          >
            <Box display={"flex"} flexDir={"column"}>
              <Text fontSize={{ base: "md", lg: "lg" }} fontWeight={"medium"}>
                {subtitle}
              </Text>
              <Box
                display={"flex"}
                rowGap={2}
                columnGap={4}
                flexWrap={{ base: "wrap", lg: "nowrap" }}
                alignItems={"center"}
              >
                {leftElement}
              </Box>
            </Box>
          </SkeletonText>
        </Box>
      </Box>
      {rightElement}
    </Box>
  );

  return (
    <Box
      minH={"320px"}
      w={"100%"}
      borderRadius={["none", "none", "lg"]}
      overflow={"hidden"}
      bg={"client.accent.background"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={backgroundImage ? "flex-end" : "stretch"}
    >
      {backgroundImage ? (
        <GradientMaskedImage imageUrl={backgroundImage}>
          {inner}
        </GradientMaskedImage>
      ) : (
        <Box
          flex={1}
          display={"flex"}
          flexDir={"column"}
          w={"100%"}
          h={"100%"}
          justifyContent={"flex-end"}
        >
          <Box
            minH={"250px"}
            display={"flex"}
            flexDir={"column"}
            justifyContent={"flex-end"}
          >
            {inner}
          </Box>
        </Box>
      )}
    </Box>
  );
}
